import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CommonState, DepositLimitPeriods } from "@obg/ngx.common";
import { DepositLimitAction, MultiDepositLimits, MultiDepositLimitSelector } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { MultiDepositLimitDialogData } from "../multi/multi-deposit-limit.model";

@Component({
	selector: "obg-m-multi-deposit-limit-message",
	templateUrl: "multi-deposit-limit-message.component.html",
	styleUrls: ["multi-deposit-limit-message.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiDepositLimitMessageComponent {
	@HostBinding("class.multi-deposit-limit-message") hostCssClass = true;

	multiDepositLimits$: Observable<MultiDepositLimits | undefined> | undefined;
	depositLimitPeriods: string[] = Object.values(DepositLimitPeriods);

	constructor(
		private store: Store<CommonState>,
		private multiDepositLimitSelector: MultiDepositLimitSelector,
		private dialogRef: MatDialogRef<MultiDepositLimitMessageComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: MultiDepositLimitDialogData,
		private depositLimitAction: DepositLimitAction
	) {
		this.multiDepositLimits$ = this.store.select(this.multiDepositLimitSelector.get());
	}

	onConfirm() {
		if (this.dialogData.isPostLogin && this.dialogData.newDepositLimits) {
			this.store.dispatch(
				this.depositLimitAction.acceptUnconfirmed({
					depositLimitId: this.dialogData.newDepositLimits.depositLimitId,
				})
			);
			this.dialogRef.close();
		} else {
			this.dialogRef.close(true);
		}
	}

	onCancel() {
		if (this.dialogData.isPostLogin && this.dialogData.newDepositLimits) {
			this.store.dispatch(
				this.depositLimitAction.declineUnconfirmed({
					depositLimitId: this.dialogData.newDepositLimits.depositLimitId,
				})
			);
			this.dialogRef.close();
		} else {
			this.dialogRef.close(false);
		}
	}
}
